import React from 'react'

import { ClassList, ClassCreate, AdminStudentToClass } from '../Components/ClassManagement'
import { AdminProfile } from '../Components/Common/AdminProfile'
import { ProfileEdit } from '../Components/Common/ProfileEdit'
import { ChangePassword } from '../Components/Common/ChangePassword'
import { AdminStudentList, AdminStudentCreate, AdminStudentEdit, AdminStudentDetail, AdminStudentRoleChange } from '../Components/StudentManagement'
import {
	AdminInstructorList,
	AdminInstructorCreate,
	AdminInstructorEdit,
	AdminInstructorDetail,
	AdminInstructorSuccess
} from '../Components/InstructorManagement'
import { AdminPrivateNoteList, AdminPrivateNoteEdit } from '../Components/PrivateNoteManagement'
import { AdminParameterList, AdminParameterEdit } from '../Components/ParameterManagement'
import { AdminBookList, AdminBookEdit } from '../Components/BookManagement'
import { AdminCollegeList, AdminCollegeEdit, AdminCollegeList2, AdminCollegeEdit2 } from '../Components/CollegeManagement'
import { AdminProgressCheckList, AdminProgressCheckAdd } from '../Components/ProgressCheckManagement'

export const adminRoutes = [
	// Class Management Routes
	{ path: `${process.env.PUBLIC_URL}/admin/class-management/:layout`, Component: <ClassList /> },
	{ path: `${process.env.PUBLIC_URL}/admin/class-management/create/:layout`, Component: <ClassCreate /> },
	{ path: `${process.env.PUBLIC_URL}/admin/class-management/edit/:id/:layout`, Component: <ClassCreate /> },
	{ path: `${process.env.PUBLIC_URL}/admin/class-management/add-student/:id/:layout`, Component: <AdminStudentToClass /> },

	// Student Management Routes
	{ path: `${process.env.PUBLIC_URL}/admin/students/:layout`, Component: <AdminStudentList /> },
	{ path: `${process.env.PUBLIC_URL}/admin/students/create/:layout`, Component: <AdminStudentCreate /> },
	{ path: `${process.env.PUBLIC_URL}/admin/students/edit/:id/:type/:layout`, Component: <AdminStudentEdit /> },
	{ path: `${process.env.PUBLIC_URL}/admin/students/detail/:id/:layout`, Component: <AdminStudentDetail /> },
	{ path: `${process.env.PUBLIC_URL}/admin/students/role-change/:id/:layout`, Component: <AdminStudentRoleChange /> },

	// Instructor Management Routes
	{ path: `${process.env.PUBLIC_URL}/admin/instructors/:layout`, Component: <AdminInstructorList /> },
	{ path: `${process.env.PUBLIC_URL}/admin/instructors/create/:layout`, Component: <AdminInstructorCreate /> },
	{ path: `${process.env.PUBLIC_URL}/admin/instructors/edit/:id/:type/:layout`, Component: <AdminInstructorEdit /> },
	{ path: `${process.env.PUBLIC_URL}/admin/instructors/detail/:id/:layout`, Component: <AdminInstructorDetail /> },
	{ path: `${process.env.PUBLIC_URL}/admin/instructors/success/:id/:layout`, Component: <AdminInstructorSuccess /> },

	// Private Note Management Routes
	{ path: `${process.env.PUBLIC_URL}/admin/private-notes/:layout`, Component: <AdminPrivateNoteList /> },
	{ path: `${process.env.PUBLIC_URL}/admin/private-notes/create/:layout`, Component: <AdminPrivateNoteEdit /> },
	{ path: `${process.env.PUBLIC_URL}/admin/private-notes/edit/:id/:layout`, Component: <AdminPrivateNoteEdit /> },

	// Parameter Management Routes
	{ path: `${process.env.PUBLIC_URL}/admin/parameters/:layout`, Component: <AdminParameterList /> },
	{ path: `${process.env.PUBLIC_URL}/admin/parameters/create/:layout`, Component: <AdminParameterEdit /> },
	{ path: `${process.env.PUBLIC_URL}/admin/parameters/edit/:id/:layout`, Component: <AdminParameterEdit /> },

	// Book Management Routes
	{ path: `${process.env.PUBLIC_URL}/admin/books/:layout`, Component: <AdminBookList /> },
	{ path: `${process.env.PUBLIC_URL}/admin/books/create/:layout`, Component: <AdminBookEdit /> },
	{ path: `${process.env.PUBLIC_URL}/admin/books/edit/:id/:layout`, Component: <AdminBookEdit /> },

	// College Management Routes
	{ path: `${process.env.PUBLIC_URL}/admin/colleges/:layout`, Component: <AdminCollegeList /> },
	{ path: `${process.env.PUBLIC_URL}/admin/colleges/create/:layout`, Component: <AdminCollegeEdit /> },
	{ path: `${process.env.PUBLIC_URL}/admin/colleges/edit/:id/:layout`, Component: <AdminCollegeEdit /> },

	{ path: `${process.env.PUBLIC_URL}/admin/college-list-2/:layout`, Component: <AdminCollegeList2 /> },
	{ path: `${process.env.PUBLIC_URL}/admin/college-list-2/create/:layout`, Component: <AdminCollegeEdit2 /> },
	{ path: `${process.env.PUBLIC_URL}/admin/college-list-2/edit/:id/:layout`, Component: <AdminCollegeEdit2 /> },

	// Progress Check Management Routes
	{ path: `${process.env.PUBLIC_URL}/admin/progress-check/:layout`, Component: <AdminProgressCheckList /> },
	{ path: `${process.env.PUBLIC_URL}/admin/progress-check/create/:layout`, Component: <AdminProgressCheckAdd /> },

	// Profile Management Routes
	{ path: `${process.env.PUBLIC_URL}/admin/profile/:layout`, Component: <AdminProfile /> },
	{ path: `${process.env.PUBLIC_URL}/admin/profile-edit/:layout`, Component: <ProfileEdit /> },
	{ path: `${process.env.PUBLIC_URL}/admin/change-password/:layout`, Component: <ChangePassword /> }
]
